import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

export interface TokenListStateCellProps
  extends CellContext<GatewayTokenModel, GatewayTokenModel['valid']> {}

export const TokenListValidCell = (
  props: TokenListStateCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  if (getValue()) {
    return (
      <Tag className="bg-surface-success">
        {t('delmonicos-shared-sdk.outputs-token-is-valid.VALID')}
      </Tag>
    );
  }

  return (
    <Tag className="bg-surface-error">
      {t('delmonicos-shared-sdk.outputs-token-is-valid.INVALID')}
    </Tag>
  );
};
